/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
  CircularProgress,
  Grid,
  Hidden,
  ListItemIcon,
  ListItemText,
  Menu,
} from "@mui/material";
import HypetBreadcrumbs from "../Breadcrumbs";
import { AppContext } from "../../../../App";
import { useDispatch, useSelector } from "react-redux";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Axios from "../../../../Utils/AxiosConfig/axiosConfig";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import ShareIcon from "@mui/icons-material/Share";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { loadSnackbar } from "../../../../Utils/util";
import { ExcelService } from "../../../../Utils/ExportToExcel";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import RefreshIcon from "@mui/icons-material/Refresh";
import UpdateIcon from "@mui/icons-material/Update";
import CompareBtn from "../../utils/CompareBtn";
import SubHeader from "../SubHeader";

interface PageCTA {
  buttonName: string;
  buttonAction?: string;
}
interface BreadcrumbsNavigationItem {
  menuName?: string;
  menuAction?: string;
}

interface InjectionMouldingHeaderProps {
  pageHeader?: string;
  pageCTA?: PageCTA[];
  navigationItem?: BreadcrumbsNavigationItem[];
  asset?: any;
  showExporAndRefresh?: boolean;
  finalExcelData?: any;
  timeGranularity?: string;
  refresh?: any;
  setRefresh?: any;
  setCurrentList?: any;
  compareAssets?: any;
  removeSelectedTag?: any;
}

const refreshOptions = [
  { value: 0, label: "Disabled" },
  { value: 30, label: "30 seconds" },
  { value: 60, label: "1 minute" },
  { value: 300, label: "5 minutes" },
  { value: 1800, label: "30 minutes" },
];

const InjectionMouldingHeader: React.FC<InjectionMouldingHeaderProps> = ({
  pageHeader,
  pageCTA,
  navigationItem,
  asset = {},
  showExporAndRefresh = false,
  finalExcelData = [],
  timeGranularity = "",
  refresh = false,
  setRefresh = () => {},
  setCurrentList = () => {},
  compareAssets = [],
  removeSelectedTag = () => {},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const usecaseList = useSelector((state: any) => state.usecaseList);
  const usersList = useSelector((state: any) => state.usersList);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentUsecase, setCurrentUsecase] = React.useState<any>([]);
  const open = Boolean(anchorEl);
  const [isLoadingCSV, setIsLoadingCSV] = React.useState<any>(false);
  const [anchorElRefresh, setAnchorElRefresh] = React.useState(null);
  const refreshIntervalPreference = localStorage.getItem("refreshInterval");
  const [refreshInterval, setRefreshInterval] = useState(0);
  const [anchorTroubleshootEl, setAnchorTroubleshootEl] = React.useState(null);
  const troubleShootMenuOpen = Boolean(anchorTroubleshootEl);
  const openRefresh = Boolean(anchorElRefresh);

  const compare = () =>
    navigate("/usecase/injection-pdm/troubleshooting-module");

  const extractedUsecase = window.location.href.substring(
    window.location.href.indexOf("usecase/") + 8
  );
  //getting usecase from url
  const usecaseUrl = extractedUsecase.substring(
    0,
    extractedUsecase.indexOf("/")
  );

  useEffect(() => {
    setCurrentUsecase(
      usecaseList.usecases.find((usecase: any) => {
        return usecase.routes_use_code === usecaseUrl;
      })
    );
  }, [usecaseList.usecases]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClickRefresh = (e: any) => {
    setAnchorElRefresh(e.currentTarget);
  };

  const handleCloseRefresh = () => {
    setAnchorElRefresh(null);
  };

  const handleIntervalChange = (value: any) => {
    setRefreshInterval(value);
    localStorage.setItem("refreshInterval", value);
  };

  React.useEffect(() => {
    if (refreshIntervalPreference) {
      setRefreshInterval(Number(refreshIntervalPreference));
    }
  });

  useEffect(() => {
    const IntervalId = setInterval(() => {
      if (refreshInterval > 0) {
        setCurrentList([]);
        setRefresh(!refresh);
      }
    }, refreshInterval * 1000); // Convert seconds to milliseconds

    // Clear the interval when refreshInterval changes
    return () => clearInterval(IntervalId);
  }, [refreshInterval, refresh]);

  const exportCSV = async () => {
    const excelService = new ExcelService();
    setIsLoadingCSV(true);
    try {
      if (finalExcelData.length) {
        const overViewData = [
          {
            "Asset Name": `${asset?.asset_name}`,
            "Asset Component Name": `${asset?.asset_name}`,
            "Plant Name": `${asset?.plant_name}`,
            "Report URL": window.location.href,
            "Selected Sensor":
              asset === undefined || asset === null ? "NA" : "Combined",
            Granularity:
              timeGranularity === "minute"
                ? "5 minute"
                : timeGranularity === "hour"
                ? "Hourly"
                : timeGranularity === "day"
                ? "Daily"
                : timeGranularity,
          },
        ];

        let excelSheetName = ["Asset Overview"];
        const temp = finalExcelData?.map(
          (item: any) => item?.[0]?.["RIAFiveMinAgg.description"]
        );
        excelSheetName = [...excelSheetName, ...temp];

        excelService.exportAsExcelFile(
          [overViewData, ...finalExcelData],
          `NB ARCH Report Data- ${asset?.asset_name}${
            asset === undefined || asset === null ? "" : " -Combined"
          }-${new Date().getTime()}`,
          excelSheetName
        );
        setIsLoadingCSV(false);
      } else {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            isShow: true,
            message: "Unable to Load the resource",
            type: "error",
            open: true,
          },
        });
        setIsLoadingCSV(false);
      }
    } catch (err) {
      setIsLoadingCSV(false);
      // setIsError(true);
      dispatch(loadSnackbar());
    }
  };

  const addBookmark = () => {
    Axios.post(`users/addBookmarkReport`, {
      userId: usersList.currentUser._id,
      assetId: asset?._id,
      usecaseId: currentUsecase?._id,
    })
      .then((res) => {
        // After updating the bookmark details we need to update the current user data which is in the local state
        dispatch({
          type: "SET_CURRENT_USER",
          payload: res.data.updatedUserDetails,
        });
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Report successfully added to bookmarks",
            type: "success",
            open: true,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Something went wrong!",
            type: "error",
            open: true,
          },
        });
      });
  };

  const removeBookmark = () => {
    Axios.post(`users/removeBookmarkReport`, {
      userId: usersList.currentUser._id,
      assetId: asset?._id,
      usecaseId: currentUsecase?._id,
    })
      .then((res) => {
        // After updating the bookmark details we need to update the current user data which is in the local state
        dispatch({
          type: "SET_CURRENT_USER",
          payload: res.data.updatedUserDetails,
        });
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Report successfully removed from bookmarks",
            type: "success",
            open: true,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Something went wrong!",
            type: "error",
            open: true,
          },
        });
      });
  };

  return (
    <SubHeader leftSpacing={0}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ flexGrow: 1, px: 2 }}
      >
        <Grid item>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* <IconButton color="inherit" onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton> */} 
            <Box>
              <Typography variant="h4">{pageHeader}</Typography>
              <HypetBreadcrumbs navigationItem={navigationItem} />
            </Box>
          </div>
        </Grid>
        <Grid item>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            {showExporAndRefresh && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={1}
                  justifyContent="right"
                  display="flex"
                  alignItems="center"
                  sx={{ marginRight: { xs: "5px", sm: "unset" } }}
                >
                  <IconButton
                    aria-controls={openRefresh ? "refresh-menu" : undefined}
                    aria-expanded={openRefresh ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleClickRefresh}
                    aria-label="Refresh Options"
                    title="Refresh Options"
                    disableRipple
                  >
                    <ManageHistoryIcon />
                  </IconButton>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={1}
                  className="hide-print"
                  justifyContent="right"
                  display="flex"
                >
                  <IconButton
                    aria-controls={open ? "long-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    aria-label="Open to show more"
                    title="Open to show more"
                    disableRipple
                  >
                    <MoreVertIcon />
                  </IconButton>
                </Grid>
                <CompareBtn
                  setAnchorTroubleshootEl={setAnchorTroubleshootEl}
                  anchorTroubleshootEl={anchorTroubleshootEl}
                  troubleShootMenuOpen={troubleShootMenuOpen}
                  compareAssets={compareAssets}
                  removeSelectedTag={removeSelectedTag}
                  compare={compare}
                />
              </>
            )}
            {pageHeader?.toLowerCase()?.includes("silo") && (
              <CompareBtn
                setAnchorTroubleshootEl={setAnchorTroubleshootEl}
                anchorTroubleshootEl={anchorTroubleshootEl}
                troubleShootMenuOpen={troubleShootMenuOpen}
                compareAssets={compareAssets}
                removeSelectedTag={removeSelectedTag}
                compare={compare}
              />
            )}
            <Menu
              id="refresh-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorElRefresh}
              open={openRefresh}
              onClose={handleCloseRefresh}
              TransitionProps={{
                timeout: 0,
              }}
              className="hide-print"
            >
              <MenuList
                style={{
                  background: "#343D70",
                  padding: "0px",
                }}
              >
                {/* Manual Refresh Option */}
                <MenuItem
                  // style={{ backgroundColor: "#343D70" }}
                  onClick={() => {
                    setCurrentList([]);
                    // fetchAnnotations();
                    setRefresh(!refresh);
                    handleCloseRefresh();
                  }}
                >
                  <ListItemIcon>
                    <RefreshIcon style={{ color: "white" }} fontSize="medium" />
                  </ListItemIcon>
                  <ListItemText>{"Refresh Now"}</ListItemText>
                </MenuItem>
                {/* Auto Refresh Options */}
                {refreshOptions.map((option) => (
                  <MenuItem
                    onClick={() => {
                      handleIntervalChange(Number(option.value));
                      handleCloseRefresh();
                    }}
                  >
                    <ListItemIcon>
                      {Number(option.value) === refreshInterval ? (
                        <UpdateIcon
                          style={{ color: "#1dac56" }}
                          fontSize="medium"
                        />
                      ) : (
                        <UpdateIcon
                          style={{ color: "white" }}
                          fontSize="medium"
                        />
                      )}
                    </ListItemIcon>
                    <ListItemText>{`Auto Refresh ${option.label}`}</ListItemText>
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              TransitionProps={{
                timeout: 0,
              }}
              className="hide-print"
            >
              <MenuList
                style={{
                  background: "#343D70",
                  padding: "0px",
                }}
              >
                <Hidden mdDown>
                  <MenuItem
                    // style={{ backgroundColor: "#343D70" }}
                    onClick={() => {
                      window.print();
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <PictureAsPdfIcon
                        style={{ color: "white" }}
                        fontSize="small"
                      />
                    </ListItemIcon>
                    <ListItemText>Export PDF</ListItemText>
                  </MenuItem>
                </Hidden>
                <MenuItem
                  // style={{ backgroundColor: "#343D70" }}
                  onClick={() => {
                    exportCSV();
                  }}
                >
                  <ListItemIcon>
                    <InsertDriveFileIcon
                      style={{ color: "white" }}
                      fontSize="small"
                    />
                  </ListItemIcon>
                  <ListItemText>
                    {isLoadingCSV === true ? (
                      <CircularProgress
                        size="19px"
                        style={{ color: "white" }}
                      />
                    ) : (
                      "Export Excel"
                    )}
                  </ListItemText>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (
                      usersList.currentUser?.bookmarked_reports
                        ?.filter(
                          (data: any) =>
                            data?.usecase_id === currentUsecase?._id
                        )
                        ?.map((assetData: any) => assetData.assets)
                        .flat()
                        ?.includes(asset?._id)
                    ) {
                      removeBookmark();
                    } else {
                      addBookmark();
                    }
                  }}
                >
                  <ListItemIcon>
                    {usersList.currentUser?.bookmarked_reports
                      ?.filter(
                        (data: any) => data?.usecase_id === currentUsecase?._id
                      )
                      ?.map((assetData: any) => assetData.assets)
                      .flat()
                      ?.includes(asset?._id) ? (
                      <BookmarkRemoveIcon
                        style={{ color: "white" }}
                        fontSize="small"
                      />
                    ) : (
                      <BookmarkAddIcon
                        style={{ color: "white" }}
                        fontSize="small"
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText>
                    {usersList.currentUser.bookmarked_reports
                      ?.filter(
                        (data: any) => data?.usecase_id === currentUsecase?._id
                      )
                      .map((assetData: any) => assetData.assets)
                      .flat()
                      ?.includes(asset?._id)
                      ? "Remove Bookmark"
                      : "Bookmark Report"}
                  </ListItemText>
                </MenuItem>
                <MenuItem
                  // style={{ backgroundColor: "#343D70" }}
                  onClick={() => {
                    window.open(
                      "mailto:digitaltechnologyteam@niagarawater.com?Subject=" +
                        encodeURIComponent(
                          `Report Data- ${asset?.asset_name}${
                            asset?.description === undefined
                              ? "- Combined"
                              : `- ${asset?.description}`
                          }`
                        ) +
                        "&body=" +
                        encodeURIComponent(
                          `Hi team, please find the report for ${
                            asset?.asset_name
                          }${
                            asset === undefined || asset === null
                              ? " here."
                              : asset?.description === undefined
                              ? "- Combined here."
                              : `-${asset?.description} here.`
                          }\n\n Please copy the below link and paste it in your browser \n\n ${
                            window.location
                          } \r\n`
                        )
                    );
                  }}
                >
                  <ListItemIcon>
                    <ShareIcon style={{ color: "white" }} fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Share Report</ListItemText>
                </MenuItem>
              </MenuList>
            </Menu>
            <Grid container spacing={1} justifyContent="flex-end">
              {pageCTA &&
                pageCTA?.map((item: any) => {
                  return (
                    <Grid item>
                      <Button
                        variant="outlined"
                        size="large"
                        fullWidth
                        onClick={() => navigate(item.buttonAction)}
                      >
                        {item.buttonName}
                      </Button>
                    </Grid>
                  );
                })}
            </Grid>
            
          </Box>
        </Grid>
      </Grid>
    </SubHeader>
  );
};

export default InjectionMouldingHeader;
